<!--  -->
<template>
  <div class="box">
    <div class="main">
      <div class="w">
        <div class="xingxi">
          <div class="tiao"></div>
          <i>泰瑞学院</i>
        </div>
        <el-card>
          <ul>
            <li v-for="item in dataList" :key="item.id">
              <div class="biaoqian">{{ item.data.biaoqian }}</div>
              <div
                class="neirong cleafix"
                v-for="(item, i) in item.data.course"
                :key="i"
              >
                <i>{{ item.kechengming }}</i>
                <el-link
                  type="primary"
                  :href="item.xiazai"
                  target="_blank"
                  class="right xiazai"
                  >资料下载</el-link
                >
                <el-link
                  v-if="item.wenjianleixing == 'pdf'"
                  :href="item.xiazai"
                  target="_blank"
                  type="primary"
                  class="right yulan"
                  >在线预览</el-link
                >
                <el-link
                  v-if="item.wenjianleixing == '视频'"
                  type="primary"
                  @click="tankuang(item.yulan)"
                  class="right yulan"
                  >在线预览</el-link
                >
                <span class="right">{{ item.zhuti }}</span>
                <i
                  class="right"
                  style="padding-right: 80px;box-sizing: border-box;"
                  >{{ item.wenjianleixing == "pdf" ? "文档" : "视频" }}</i
                >
              </div>
            </li>
          </ul>
        </el-card>
      </div>

      <div
        class="mask"
        v-if="dialogVisible"
        @click="dialogVisible = false"
      ></div>
      <!-- <div class="pop" v-if="dialogVisible"> -->
      <iframe
        v-if="dialogVisible"
        class="pop"
        style="z-index:1;"
        :src="this.shipin"
        allowfullscreen=""
        frameborder="0"
        height="375"
        width="700"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      list: { function: "t_common" },
      dataList: [],
      shipin: ""
    };
  },
  computed: {
    reversedMessage: function() {
      return this.username.replace(/(^\d{3}|\d{4}\B)/g, "$1-");
    }
  },
  //方法集合
  methods: {
    tankuang(yulan) {
      var arr = yulan.split("/");
      var arr1 = arr[arr.length - 1];
      var arr2 = arr1.split(".html")[0];
      this.shipin = `https://v.qq.com/iframe/player.html?vid=${arr2}&amp;width=700&amp;height=375&amp;auto=0`;

      this.dialogVisible = true;
    },
    async huoqu() {
      const { data: dt } = await this.$http.post("/general/query", this.list);
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      dt.data.forEach((element, i) => {
        element.data = JSON.parse(element.data);

        dt.data[i] = element;
      });

      this.dataList = dt.data;
      this.dataList.forEach(v => {
        v.data.course.forEach((e, i) => {
          e = JSON.parse(e);
          v.data.course[i] = e;
          // console.log(e);
        });
      });
      // console.log(this.dataList);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    }
  },
  created() {
    this.huoqu();
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.bianqian {
  margin-left: 100px;
}
.mask {
  background-color: #000;
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pop {
  background-color: #fff;

  position: fixed;
  top: 100px;
  left: 550px;
  // width: calc(100% - 600px);
  // height: calc(100% - 200px);
  z-index: 2;
}

.cleafix::after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  clear: both;
  visibility: hidden;
}
.cleafix {
  zoom: 1;
}

.xingxi {
  //   width: 90px;
  margin-bottom: 20px;
  //   margin-top: 40px;
  //   position: absolute;
  //   left: 50px;
  //   top: 60px;

  .tiao {
    width: 4px;
    height: 15px;
    background: rgba(0, 134, 253, 1);
    display: inline-block;
    margin-right: 10px;
  }
  i {
    // width: 65px;
    font-weight: bold;
    font-size: 16px;
  }
}
.biaoqian {
  background: #0086fd;
  color: #fff;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  box-sizing: border-box;
}
.neirong {
  padding-left: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #bcd4e9;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  span {
    padding-right: 80px;
    box-sizing: border-box;
  }
}
.left {
  float: left;
}
.right {
  float: right;
}
.yulan {
  padding-right: 20px;
  box-sizing: border-box;
}
.xiazai {
  padding-right: 20px;
  box-sizing: border-box;
}
.main {
  margin-top: 60px;
  background-color: rgba(245, 245, 245);
  padding-top: 40px;
  padding-bottom: 100px;
  box-sizing: border-box;

  li {
    list-style-type: none;
    width: 100%;
    margin-bottom: 20px;
  }
  ul {
    width: 90%;
    margin: 0 auto;
    // margin-top: 100px;
  }
}
i {
  font-style: normal;
}
li {
  list-style-type: none;
}
ul {
  margin: 0;
  padding: 0;
}
.box {
  width: 100%;
  height: 100%;
}
/* 版心 */
.w {
  width: 1190px;
  margin: 0 auto;
  //   position: relative;
}
</style>
